import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { largeElevation, mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
const { responsiveText, spacing } = theme;

export const reviewItem = css`
  display: flex;
  flex-direction: column;
  padding: ${spacing.md}px;
  border-radius: ${spacing.sm}px;
  gap: ${spacing.xs}px;
  background-color: var(--neutral-white-base);
  ${largeElevation};

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      padding: ${spacing.sm}px;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      padding: ${spacing.md}px;
    `,
  )}
`;

export const ratingSection = css`
  display: flex;
  align-items: center;
  gap: ${spacing.xs}px;
`;

export const dateText = css`
  ${responsiveText.BODY.XS};
`;

export const commentText = css`
  ${responsiveText.BODY.MD};
  padding: 0;
  margin: 0;
`;

export const partnerResponseWrapper = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing.xs}px;
  ${responsiveText.BODY.MD};
  padding: ${spacing.md}px;
  border-radius: ${spacing.xs}px;
  background-color: var(--brand-purple-5);
  color: var(--neutral-black-70);
  position: relative; // to have a position relative for the visuallyHidden element
`;

export const partnerWrapper = css`
  ${responsiveText.BODY.XS};
  margin: 0;
`;

export const partnerName = css`
  font-weight: bold;
  margin-left: ${spacing.xs}px;
`;

export const readMoreButtonText = css`
  z-index: 1;
  margin-right: ${spacing.xs}px;
`;

export const expandingButton = css`
  display: flex;
  position: relative;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  width: 100%;
  padding: 0;
  border: none;
  text-decoration: none;
  ${responsiveText.BODY.MD};
  font-weight: bold;
  color: var(--brand-purple-base);
  background-color: transparent;
`;
